import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import TabsPage from '../views/TabsPage.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/tabs/welcome'
  },
  {
    path: '/tabs/',
    component: TabsPage,
    children: [
      {
        path: '',
        redirect: '/tabs/welcome'
      },
      {
        path: 'home',
        component: () => import('@/views/HomeScreen.vue')
      },
      {
        path: 'welcome',
        component: () => import('@/views/AppOnboarding.vue')
      },
      {
        path: 'quiz',
        component: () => import('@/views/QuizScreen.vue')
      },
      {
        path: 'interestingfacts',
        component: () => import('@/views/InterestingFactsScreen.vue')
      },
      {
        path: 'sharedresultsview',
        component: () => import('@/views/SharedResultsView.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
